import React from 'react';

// King game actions: draw offer/accept/decline + resign
const KingActions = ({
  game,
  hasPendingDrawOffer,
  madeDrawOffer,
  offerDraw,
  acceptDraw,
  declineDraw,
  resign,
}) => {
  return (
    <div className="king-game-actions">
      {/* Pending Draw Offer from Opponent */}
      {hasPendingDrawOffer && (
        <div className="draw-offer-received">
          <span className="draw-offer-text">
            {game.drawOffer?.from === 'white' ? 'White' : 'Black'} King offers a draw!
          </span>
          <button onClick={acceptDraw} className="accept-draw-button">
            Accept Draw
          </button>
          <button onClick={declineDraw} className="decline-draw-button">
            Decline
          </button>
        </div>
      )}

      {/* Made Draw Offer - Waiting */}
      {madeDrawOffer && (
        <div className="draw-offer-pending">
          <span className="draw-offer-waiting">Draw offer sent. Waiting for opponent...</span>
        </div>
      )}

      {/* Normal state */}
      {!hasPendingDrawOffer && !madeDrawOffer && (
        <div className="game-action-buttons">
          <button onClick={offerDraw} className="offer-draw-button">
            Offer Draw
          </button>
          <button onClick={resign} className="resign-button">
            Resign
          </button>
        </div>
      )}
    </div>
  );
};

export default KingActions;
